module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-lg-8"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [_c('i', {
    staticClass: "far fa-file-invoice m-r-sm"
  }), _vm._v(" Invoice " + _vm._s(_vm.decorated.xero_number))])], 1), _vm._v(" "), (_vm.notLoading) ? _c('div', {
    staticClass: "col-sm-4 col-lg-4"
  }, [(!_vm.decorated.isPaid) ? _c('p', {
    staticClass: "invoice-due"
  }, [_vm._v("Due: " + _vm._s(_vm.decorated.remaining))]) : _c('p', {
    staticClass: "invoice-due complete"
  }, [_vm._v("Paid")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0926959e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/ShowHeading.vue
// module id = 926
// module chunks = 0